import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';

import Table from 'material-ui/Table/Table';
import TableBody from 'material-ui/Table/TableBody';
import TableCell from 'material-ui/Table/TableCell';
import TableHead from 'material-ui/Table/TableHead';
import TableRow from 'material-ui/Table/TableRow';
import Select from 'material-ui/Select';
import TablePagination from 'material-ui/Table/TablePagination';
import { MenuItem } from 'material-ui/Menu';

const styles = theme => ({
  card: {
    display: 'flex',
    boxShadow: 'none',
  },
  content: {
    flex: '1 0 auto',
  },
  paperStyle: {
    width: '70%',
    height: '70%',
    display: 'inline-block',
    margin: 20,
    marginTop: '12vh'
  },
  buttonStyle: {
    marginTop: 10,
    marginBottom: 15
  },
  marginStyle: {
    margin: 8
  },
  textField: {
    width: 350,
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  radioGroup: {
    marginTop: '2%',
    marginLeft: '9%',
    textAlign: 'left',
  },
  headerStyle: {
    position: 'relative',
    width: '100%',
    height: '60px',
    background: '#FFFFFF',
    boxShadow: 'none'
  },
  headerTitleStyle: {
    margin: '2%',
    fontSize: '24px',
    fontFamily: 'Roboto',
    display: 'flex',
    justifyContent: 'space-between'
  },
  addIcon: {
    position: 'absolute',
    margin: '1%'
  },
  toolTipStyle: {
    margin: '5%',
    width: '87.1%'
  }
});


class LocationSelector extends Component {
  state = {
    page: 0,
    pageSize: 5
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  render() {
    const { classes, locations, person, changeRoleForLocation } = this.props;
    const { page, pageSize } = this.state;
    return (
      <div>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>Location Name</TableCell>
              <TableCell>Company Name</TableCell>
              <TableCell>Role</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {locations.slice(page * pageSize, (page * pageSize) + pageSize).map(l => (
              <TableRow key={l.locationId}>
                <TableCell component="th" scope="row">{l.locationName}</TableCell>
                <TableCell>{l.companyName}</TableCell>
                <TableCell>
                  <Select
                    value={(person &&
                        person.locations &&
                        person.locations.find(o => o.locationId === l.locationId) &&
                        `${person.locations.find(o => o.locationId === l.locationId).roleId},${l.locationId}`
                      ) || ''
                    }
                    onChange={changeRoleForLocation}
                  >
                    <MenuItem value={`remove,${l.locationId}`} />
                    <MenuItem value={`e030c1e6-aa56-483a-b335-10c3ff8e31a8,${l.locationId}`}>User</MenuItem>
                    <MenuItem value={`5a7273e1-c15e-4e54-b2b7-922b4606e65a,${l.locationId}`}>Admin</MenuItem>
                    <MenuItem value={`c86cf16f-cc5e-4d59-b37a-1093ee27cf13,${l.locationId}`}>System Admin</MenuItem>
                  </Select>
                </TableCell>
              </TableRow>))}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={locations.length}
          rowsPerPage={this.state.pageSize}
          page={this.state.page}
          rowsPerPageOptions={[5]}
          backIconButtonProps={{
            'aria-label': 'Previous Page',
          }}
          nextIconButtonProps={{
            'aria-label': 'Next Page',
          }}
          onChangePage={this.handleChangePage}
        />
      </div>
    );
  }
}

LocationSelector.propTypes = {
  classes: PropTypes.shape().isRequired
};

const mapStateToProps = (state, ownProps) => ({
  data: {
    config: state.config.config,
    person: state.person.person,
  }
});

const mapDispatchToProps = dispatch => ({
  actions: {}
});


const ReduxForm = withStyles(styles, { withTheme: true })(reduxForm({
  form: 'LocationSelectorForm',
  enableReinitialize: true
})(LocationSelector));

const ConnectedLocationSelectorForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReduxForm);

export default ConnectedLocationSelectorForm;


// WEBPACK FOOTER //
// ./src/components/Customer/User/LocationSelector.js